export default __webpack_public_path__ + "static/media/chemistry.f509b9f0.png";